import AntdInputGroup from 'antd/lib/input/Group';

export default AntdInputGroup;
